<ng-container *ngIf="title">
    <h3 class="title">{{ title }}</h3>
</ng-container>
<p class="description">{{ description }}</p>
<msc-button type="fab" icon="icon-close-circle" (click)="onClose()"></msc-button>
